import { clientAuthAxios } from '../clientAuth';
import { wafClientAuthAxios } from '../awsWaf';
import { ValidateEmailRequestParameters, ValidateEmailResponse } from './types';

/**
 * A function that posts to the `/client-auth-api/api/validate_email` endpoint.
 *
 * - [Documentation](https://unwritten.stitchfix.com/apidocs/web/client-auth-api/validate_emails_(v1)/post_validate_email_client_does_not_exist.html)
 * - [Implementation](https://github.com/stitchfix/client-auth-api/blob/main/app/controllers/api/v1/validate_emails_controller.rb)
 */
export const validateEmail = (emailValidationRequestParameters: ValidateEmailRequestParameters, isWafEnabled = false) => {
  const apiService = isWafEnabled ? wafClientAuthAxios : clientAuthAxios;
  return apiService.post<ValidateEmailResponse>('validate_email', emailValidationRequestParameters);
};